import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography, } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAppbar, } from '../../../hooks';
import CustomizedListPages from './CustomizedListPages';

export default function AccordionMenu({ pages, sx = [], ...props}) {
    const { accordionMenuIsOpen, accordionMenuToggle, } = useAppbar();

    return (
        <Accordion
            disableGutters
            elevation={0}
            expanded={accordionMenuIsOpen}
            onChange={() => accordionMenuToggle()}
            sx={[
                {
                    '&::before': {
                        display: 'none',
                    },
                },
                ...(Array.isArray(sx) ? sx : [sx])
            ]}
            { ...props }>
            <AccordionSummary expandIcon={<ExpandMoreIcon  sx={{ color: 'text.primary', }} />}>
                <Typography sx={{ color: 'text.primary', fontSize: 14, }}>Навигация</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ borderTop: 1, borderColor: 'borderColor.main', py: 1.5, }}>
                <CustomizedListPages pages={pages} />
            </AccordionDetails>
        </Accordion>
    )
};